<template>
  <Modal v-model="visible" class="my-modal" title="新单进度" width="1000" footer-hide>
    <div class="record-wrap">
      <div class="policyNo">保单号：{{ detailData.policyNo }}</div>
      <div class="record-box">
        <Timeline>
          <TimelineItem v-for="(item, rIdx) in recordList" :key="rIdx">
            <div slot="dot" class="dot" :class="{ first: rIdx === 0 }"></div>
            <div class="time-item-header">
              <div class="time-item-header__l">
                <div class="time-item-header__l-text" :class="{ first: rIdx === 0 }">{{ item.createTime }}</div>
                <div class="time-item-header__l-status-desc" :class="[getStatusClass(rIdx, item)]">
                  <policyStatusTxt :formData="item" />
                </div>
              </div>
              <div class="time-item-header__operator">
                <!-- <div class="time-item-header__operator__text">操作人：{{ item.operatorName }}</div> -->
              </div>
            </div>
            <Card>
              <Row>
                <Col v-if="item.failuresDate && ['7'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">失效时间：</div>
                    <div class="info-item__content">{{ item.failuresDate | filterTime('YYYY-MM-DD') }}</div>
                  </div>
                </Col>
                <Col v-if="item.expireDate && ['7'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">保单到期日：</div>
                    <div class="info-item__content">{{ item.expireDate | filterTime('YYYY-MM-DD') }}</div>
                  </div>
                </Col>
                <Col v-if="item.underwriteTime && ['4'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">核保通过时间：</div>
                    <div class="info-item__content">{{ item.underwriteTime }}</div>
                  </div>
                </Col>
                <Col v-if="item.cancelDate && ['0'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">取消投保日期：</div>
                    <div class="info-item__content">{{ item.cancelDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.effectDate && ['1', '1_101', '1_102', '6'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">保单生效日期：</div>
                    <div class="info-item__content">{{ item.effectDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.expirationDate && ['1', '1_101', '1_102', '6'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">冷静期截止日期：</div>
                    <div class="info-item__content">{{ item.expirationDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.policySubmitDate && ['5', '6'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">交单日期：</div>
                    <div class="info-item__content">{{ item.policySubmitDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.refundDate && ['-1'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">退保日期：</div>
                    <div class="info-item__content">{{ item.refundDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.endDate && ['6'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">终止日期：</div>
                    <div class="info-item__content">{{ item.endDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.pendingDate && ['3_301'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">pending下发日期：</div>
                    <div class="info-item__content">{{ item.pendingDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.pendingHandleDate && ['3_302'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">pending处理日期：</div>
                    <div class="info-item__content">{{ item.pendingHandleDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.pendingRemark && ['3_301', '3_302'].includes(item._status)" :span="24">
                  <div class="info-item">
                    <div class="info-item__label">pending备注：</div>
                    <div class="info-item__content">
                      <div class="text">{{ item.pendingRemark }}</div>
                    </div>
                  </div>
                </Col>
                <Col v-if="item.failuresReason && ['7'].includes(item._status)" :span="24">
                  <div class="info-item">
                    <div class="info-item__label">失效原因：</div>
                    <div class="info-item__content">
                      <div class="text">{{ item.failuresReason }}</div>
                    </div>
                  </div>
                </Col>
                <Col v-if="item.payStatus !== undefined" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">缴费状态：</div>
                    <div class="info-item__content">
                      <lzDicTxt dicType="POLICY_PAY_STATUS" :dicCode="item.payStatus" />
                    </div>
                  </div>
                </Col>
                <Col v-if="item.payFee && [1, 2, 3, 5].includes(item.payStatus * 1)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">缴费金额：</div>
                    <div class="info-item__content">{{ item.payFee }}{{ item.currencyType }}</div>
                  </div>
                </Col>
                <Col v-if="item.payDate && [1, 2, 3, 5].includes(item.payStatus * 1)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">缴费日期：</div>
                    <div class="info-item__content">{{ item.payDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.submitAccountDate && [2].includes(item.payStatus * 1)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">提交对账日期：</div>
                    <div class="info-item__content">{{ item.submitAccountDate }}</div>
                  </div>
                </Col>
                <Col v-if="item.refundFeeDate && [4].includes(item.payStatus * 1)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">退费日期：</div>
                    <div class="info-item__content">{{ item.refundFeeDate }}</div>
                  </div>
                </Col>
                <!-- <Col v-if="['2'].includes(item._status)" :span="6">
                  <div class="info-item">
                    <div class="info-item__label">签单日期：</div>
                    <div class="info-item__content">{{ item.signDate }}</div>
                  </div>
                </Col> -->

                <Col v-if="item.attachmentInfo.length" :span="24">
                  <div class="files">
                    <template v-for="file in item.attachmentInfo">
                      <img v-if="file._type === 'pdf'" :key="file.path" :src="file._iconUrl" class="file" @click="handleViewFIle(file)" />
                      <img
                        v-if="file._type === 'img'"
                        :key="file.path"
                        :src="file._iconUrl"
                        class="file"
                        :preview="`policy_changeStatus_${rIdx}`"
                        preview-text="附件"
                      />
                    </template>
                  </div>
                </Col>
              </Row>
            </Card>
          </TimelineItem>
        </Timeline>
        <noData v-if="recordList && !recordList.length"></noData>
      </div>
    </div>
  </Modal>
</template>

<script>
import policyStatusTxt from '@/components/commons/policyStatusTxt';
import lzDicTxt from '@/components/commons/lzDicTxt';

export default {
  components: {
    policyStatusTxt,
    lzDicTxt,
  },
  data() {
    return {
      visible: false,
      detailData: {},
      recordList: []
    };
  },
  methods: {
    getFileIcon(path) {
      // 根据path的后缀 .png/.jpg/.jpeg/webp/pdf 返回对应的icon jpg.png/pdf.png
      const ext = path
        .split('.')
        .pop()
        .toLowerCase();
      switch (ext) {
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'webp':
          return {
            iconUrl: path,
            type: 'img'
          };
        case 'pdf':
          return {
            iconUrl: require('@/static/images/cc_pdf_new.png'),
            type: 'pdf'
          };
        default:
          return {
            iconUrl: '',
            type: ''
          };
      }
    },
    open(data = {}) {
      const loading = this.$Message.loading({
        content: '加载中',
        duration: 0
      });
      this.detailData = {};
      this.recordList = [];
      this.detailData = JSON.parse(JSON.stringify(data));
      this.detailData.policyNo = data.policyNo;
      this.$http({
        url: '/buz/policy/read/progress',
        type: 'GET',
        data: {
          policyId: data.id
        }
      })
        .then(res => {
          this.recordList = res.data.map(item => {
            item._status = this.$units.getPolicyStatus(item, []);
            if (item.attachmentInfo) {
              item.attachmentInfo = JSON.parse(item.attachmentInfo);
            }
            item.attachmentInfo = item.attachmentInfo || [];
            item.attachmentInfo.forEach(f => {
              const { iconUrl, type } = this.getFileIcon(f.path);
              f._iconUrl = iconUrl;
              f._type = type;
            });
            return item;
          });
          setTimeout(this.$previewRefresh, 500);
          loading();
          this.visible = true;
        })
        .catch(() => {
          loading();
        });
    },
    handleViewFIle(file) {
      if (file._type === 'pdf') {
        window.open(file.path);
        return;
      }
    },
    getStatusClass(rIdx, item) {
      if (rIdx === 0) {
        return 'zj-status-color--' + item._status;
      } else {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/.ivu-modal-body {
    padding-top: 20px;
  }
}
.zj-status-color--0 {
  // 已失效
  color: #8a9095 !important;
}

.zj-status-color--1 {
  // 已生效
  color: #00bb4e !important;
}

.zj-status-color--1_101 {
  // 已生效-未过冷静期
  color: #004bbb !important;
}

.zj-status-color--1_102 {
  // 已生效-已过冷静期
  color: #00bb4e !important;
}

.zj-status-color--2 {
  // 核保中
  color: #004bbb !important;
}

.zj-status-color--3 {
  // pending
  color: #f34700 !important;
}

.zj-status-color--3_301 {
  // pending-待处理
  color: #f34700 !important;
}

.zj-status-color--3_302 {
  // pending-已处理
  color: #004bbb !important;
}

.zj-status-color--4 {
  // 已核保
  color: #f34700 !important;
}

.zj-status-color--5 {
  // 已交单
  color: #004bbb !important;
}

.zj-status-color---1 {
  // 已退保
  color: #8a9095 !important;
}
.record-wrap {
  padding-left: 30px;

  .policyNo {
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .time-item-header {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    .time-item-header__l {
      display: flex;
    }
    .time-item-header__l-text {
      color: #666;
      &.first {
        color: #00bb4e;
      }
    }

    .time-item-header__l-status-desc {
      margin-left: 20px;
      color: #000;
      font-weight: bold;
    }
    .time-item-header__operator__text {
      color: #666;
    }
  }

  .record-box {
    overflow-y: auto;
    max-height: 60vh;
    padding-right: 20px;
    .ivu-row {
      margin-bottom: -10px;
    }
  }

  /deep/.ivu-timeline-item:last-child .ivu-timeline-item-tail {
    display: block;
  }

  .info-item {
    display: flex;
    color: #666666;
    margin-bottom: 10px;
  }

  .info-item__content {
    flex: 1;
  }

  .text {
    word-break: break-all;
    white-space: pre-wrap;
  }

  .files {
    margin-bottom: 3px;
    margin-top: 10px;
    .file {
      height: 140px;
      width: 140px;
      cursor: pointer;
      margin-right: 7px;
      margin-bottom: 7px;
      object-fit: cover;
      border-radius: 4px;
      &:nth-of-type(6n) {
        margin-right: 0;
      }
    }
  }
  .dot {
    display: inline-block;
    height: 6px;
    width: 6px;
    border-radius: 50%;
    background-color: #bebebe;

    &.first {
      background-color: #00bb4e;
    }
  }
}
</style>
